import { PROPERTY_INLINE_FIELDS } from '../components/tabs/propertyTabHelpers'
import type { PropertyTabInlineField } from './propertyTabValidator'
import type {
  PropertyTabFormChangePayload,
  PropertyTabLocalFormData,
  PropertyTabPropertyRecord,
} from '../types/tabs'
import type { ApplicationDetailData } from '../types/application'

export function buildPropertyTabFormChangePayload(
  newFormData: PropertyTabLocalFormData,
  context: {
    property?: PropertyTabPropertyRecord | null
    applicationAllData?: ApplicationDetailData | null
  },
): PropertyTabFormChangePayload {
  const apiFormData: PropertyTabFormChangePayload = {
    has_applied: newFormData.has_applied,
    applied_property: newFormData.has_applied === false ? '0' : '1',
    property_name: newFormData.property_name,
  }

  if (newFormData.property_id) {
    apiFormData.fk_property_id = newFormData.property_id
  }

  const { property, applicationAllData } = context
  if (property?.property_id) {
    apiFormData.fk_property_id = property.property_id
  } else if (applicationAllData?.fk_temp_property_id) {
    apiFormData.fk_temp_property_id = applicationAllData.fk_temp_property_id
  }

  if (newFormData.has_applied !== false) {
    apiFormData.rent_amount = newFormData.rent_amount ?? ''
    apiFormData.lease_start_date = newFormData.lease_start_date ?? ''
  }
  if (newFormData.lease_duration) {
    apiFormData.lease_duration = newFormData.lease_duration
  }
  apiFormData.unit_number = newFormData.unit_number ?? ''
  if (newFormData.property_state !== undefined && newFormData.property_state !== null) {
    apiFormData.property_state = newFormData.property_state
  }
  if (newFormData.rent_lease_reason) {
    apiFormData.rent_lease_reason = newFormData.rent_lease_reason
  }
  if (newFormData.invite_code) {
    apiFormData.invite_code = newFormData.invite_code
  }

  apiFormData.other_individuals = newFormData.other_individuals ? '1' : '0'
  apiFormData.co_residents = newFormData.co_residents

  if (newFormData.has_applied !== false) {
    apiFormData.agent_id = String(newFormData.agent_id ?? '')
    apiFormData.agent_name = newFormData.agent_name ?? ''
    apiFormData.agent_email = newFormData.agent_email ?? ''
    apiFormData.agent_phone = newFormData.agent_phone ?? ''
  }

  if (newFormData.agent_id && String(newFormData.agent_id) !== 'Other') {
    apiFormData.fk_agent_id = String(newFormData.agent_id)
  } else if (String(newFormData.agent_id) === 'Other') {
    apiFormData.other_agent = {
      agent_name: newFormData.agent_name || '',
      agent_email: newFormData.agent_email || '',
      agent_mobile_no: newFormData.agent_phone || '',
    }
  }

  return apiFormData
}

export function isPropertyInlineField(field: string): field is PropertyTabInlineField {
  return PROPERTY_INLINE_FIELDS.has(field)
}

export function createEmptyCoResidentRow() {
  return {
    fk_user_id: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    invite_code: '',
    phone: '',
    email: '',
    spouse: false,
    relationship: '',
    applicant_status: 'NOT_STARTED',
  }
}
